export class AppLockOptions {
  /**
   * Optional. If true, the touch screen is disabled. Default is false. Available in tvOS 10.2 and later.
   */
  public disableTouch = false;

  /**
   * Optional. If true, device rotation sensing is disabled. Default is false.
   */
  public disableDeviceRotation = false;

  /**
   * Optional. If true, the volume buttons are disabled. Default to false.
   */
  public disableVolumeButtons = false;

  /**
   * Optional. If true, the ringer switch is disabled. Default is false.
   * When disabled, the ringer behavior depends on what position the switch was in when it was first disabled.
   */
  public disableRingerSwitch = false;

  /**
   * Optional. If true, the sleep/wake button is disabled. Default is false.
   */
  public disableSleepWakeButton = false;

  /**
   * Optional. If true, the device will not automatically go to sleep after an idle period. Available in tvOS 10.2 and later.
   */
  public disableAutoLock?: boolean;

  /**
   * Optional. If true, VoiceOver is turned on. Default is false. Available in tvOS 10.2 and later.
   */
  public enableVoiceOver = false;

  /**
   * Optional. If true, Zoom is turned on. Default is false. Available in tvOS 10.2 and later.
   */
  public enableZoom = false;

  /**
   * Optional. If true, Invert Colors is turned on. Default is false. Available in tvOS 10.2 and later.
   */
  public enableInvertColors = false;

  /**
   * Optional. If true, AssistiveTouch is turned on. Default is false.
   */
  public enableAssistiveTouch = false;

  /**
   * Optional. If true, Speak Selection is turned on. Default is false.
   */
  public enableSpeakSelection = false;

  /**
   * Optional. If true, Mono Audio is turned on. Default is false.
   */
  public enableMonoAudio = false;
}
